export default __webpack_public_path__ + "static/media/slide1.98cc469f.jpg";